<div id="main-content" *ngIf="gbamSurvey ; else loading" class="wrapper has-padding margin-height zoom-margin"
  (focusout)="onFocusOutMainContent($event)">
  <form [formGroup]="contributionData">

    <h1 class="bofa--heading is-4 double-bottom-space">Global Banking and Markets</h1>

    <div class="bottom-space">
      <div class="label-space" id="contribution-radio-group-label"><abbr title="required">* </abbr>Have you made any
        political contributions within the last 24 months?
      </div>
      <mat-radio-group (focusout)="radioOnBlur()" (focusin)="radioOnFocus()" name="radioContribution"
        aria-labelledby="contribution-radio-group-label" formControlName="contribution" aria-required="true" required>
        <mat-radio-button class="minor-list-space radio-padding minor-radio-padding" value='1' name="contribution">Yes
        </mat-radio-button>
        <mat-radio-button class="minor-radio-padding" value='0' name="contribution">No</mat-radio-button>
      </mat-radio-group>
    </div>

    <mat-error *ngIf="submit.value && contribution.hasError('required') || checkRadio" class="padding-top">Please select
      Have you made any
      political
      contributions within the last 24 months?</mat-error>

    <div *ngIf="contributionData.controls.contribution.value == '1'">

      <h2 class="bofa--heading is-7 has-text-centered"><strong>BANK OF AMERICA MERRILL LYNCH GLOBAL BANKING AND
          MARKETS<br aria-hidden="true" /> TRANSFER/PRE-EMPLOYMENT POLITICAL CONTRIBUTION CERTIFICATION</strong></h2>

      <p>Various regulations, including Commodity Futures Trading Commission Rule 23.451, as well as various U.S. state
        and local statutes, govern the activities of financial institutions and certain of their employees relative to
        Political
        Contributions*. These rules can provide for firm-wide bans on entering into various categories of banking
        relationships or
        transactions with governmental entities if a Political Contribution in excess of de minimis amounts is made by a
        covered employee to a political candidate, political party committee, or political action committee. These
        include
        Political Contributions made before an individual becomes an employee of the financial institution.</p>

      <p>To ensure its compliance with such rules, Bank of America Merrill Lynch must request disclosure of certain
        information regarding Political Contributions that you may have made to political candidates within the U.S.
        (including at the federal, state, or local levels), as well as Political Contributions or payments that you may
        have made to political action committees or political parties, within the past two years.</p>

      <p>Please read the certification below, provide any details necessary to make the certification accurate, and sign
        and date the form. Thank you for your assistance.</p>

      <h3 class="bofa--heading is-7 has-no-margin"><strong>Certification</strong></h3>
      <p class="has-no-margin bottom-space"><strong>I hereby certify that I made no Political Contributions within the
          past two years, directly or
          indirectly, except as disclosed below.</strong></p>

      <div class="double-bottom-space">
        <div>
          <div class="flex-40">
            <h3 class="bofa--heading is-5">Contribution</h3>
          </div>
          <div class="flex-60">
            <div *ngIf="pcGbamList.length === 0" class="padding-top pad-left5"> <button [disabled]="pcGbamList.invalid"
                type="button" #addButtonElement class="bofa--button secondary" (click)="createContribution('')">Add
                Contribution</button>
            </div>
          </div>
        </div>

        <!-- set focus when pressing Remove button -->
        <div *ngIf="!pcGbamList.invalid" tabindex="-1" #addElement class="bofa--skiplink">
        </div>

        <!-- show horizonally -->
        <div>
          <ng-container *ngFor="let contributionForm of pcGbamList.controls; let i = index"
            [formGroup]="contributionForm" class="double-bottom-space">
            <mat-card appearance="outlined"
              class="af-mat-card mat-elevation-z flex-change double-bottom-space mat-card-padding"
              [class.border]="blueBorder" [class.border-red]="redBorder">

              <!-- set focus when pressing Add button -->
              <div *ngIf="contributionForm.invalid" tabindex="-1" #addElement class="bofa--skiplink">
              </div>

              <div class="item-display">
                <mat-form-field class="max-width width-350" hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Name of Recipient</mat-label>
                  <input matInput formControlName="recipientName" required>
                  <mat-error>Please enter Name of Recipient</mat-error>
                </mat-form-field>

                <mat-form-field class="max-width width-350" hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Amount of Contribution</mat-label>
                  <input matInput formControlName="amount" required>
                  <mat-error>Please enter Amount of Contribution</mat-error>
                </mat-form-field>
              </div>

              <div class="label-padding">
                <label class="minor-label-padding" id="amountLongLabel" for="addressInput"><abbr title="required">* </abbr>Your Principal
                  Address at Time of Contribution</label>
                <mat-form-field class="max-width width-450" hideRequiredMarker aria-describedby="amountLongLabel">
                  <input matInput id="addressInput" formControlName="address" required>
                  <mat-error>Please enter Your Principal Address at Time of Contribution</mat-error>
                </mat-form-field>
              </div>

              <div class="item-display bottom-space">
                <mat-form-field class="max-width width-350" hideRequiredMarker>
                  <mat-label> <abbr title="required">* </abbr>Date of Contribution</mat-label>
                  <input matInput [matDatepicker]="contributionDatePicker" formControlName="contributionDate" required>
                  <mat-datepicker-toggle matSuffix [for]="contributionDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #contributionDatePicker></mat-datepicker>
                  <mat-hint>Format mm/dd/yyyy</mat-hint>
                  <mat-error>Please enter Date of Contribution mm/dd/yyyy</mat-error>
                </mat-form-field>
              </div>

              <div class="label-padding">
                <label class="minor-label-padding max-width width-550" id="politicalLongLabel" for="officeRunningId"><abbr title="required">*
                  </abbr>Political
                  Office Held by Candidate or Office Sought at Time of Contribution</label>
                <mat-form-field class="max-width width-550" hideRequiredMarker aria-describedby="politicalLongLabel">
                  <input matInput id="officeRunningId" formControlName="officeRunning" required>
                  <mat-error>Political Office Held by Candidate or Office Sought at Time of Contribution</mat-error>
                </mat-form-field>

                <div class="is-taller pad-left30">
                  <button type="button" class="bofa--button primary outlined" (click)="deleteClick(i)">Remove this
                    Contribution</button>
                </div>
              </div>
            </mat-card>
          </ng-container>
        </div>
      </div>

      <div *ngIf="pcGbamList.length !== 0" class="double-bottom-space">
        <button [disabled]="pcGbamList.invalid" type="button"
          class="bofa--button secondary marginright-marginleft-block" (click)="createContribution('click')">Add
          Contribution</button>
      </div>

      <p class="bofa--heading is-8">By signing below you acknowledge that you have fully reviewed and completed the
        information above</p>

      <div class="margin-top" *ngIf="gbamSurvey">
        <app-wet-signature [signatureImg]="signatureImg" (sigURL)="getUrl($event)" (sigCheck)="sigCheck($event)">
        </app-wet-signature>
        <mat-error *ngIf="pcGbamSignature.hasError('invalid') || sigCheckValue"> Please enter electronic signature
        </mat-error>
      </div>

      <div class="is-taller">
        <mat-checkbox aria-required="true" required formControlName="pcGbamAccepted" class="minor-check-padding"
          (focusout)="confirmOnBlur()" (focusin)="confirmOnFocus()">
          <mat-label class="whitespace-normal"><abbr title="required">* </abbr>Yes, I agree that I have fully
            reviewed and completed the information above </mat-label>
        </mat-checkbox>
        <mat-error class="whitespace-normal-margintop" *ngIf="pcGbamAccepted.hasError('invalid') && check">
          Please check
          the box to agree to the above language </mat-error>
      </div>

      <div>
        <mat-form-field class="max-zoom width350-marginbottom-margintop" hideRequiredMarker>
          <mat-label><abbr title="required">* </abbr>Please enter your full name</mat-label>
          <input matInput placeholder="Full name" formControlName="pcGbamSignedName" required maxlength="250">
          <mat-error>Please enter your full name</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field class="max-zoom width-350">
          <mat-label>Date Signed</mat-label>
          <input value="{{ date }}" matInput disabled>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field class="max-zoom width-350-marginbottom" hideRequiredMarker>
          <mat-label><abbr title="required">* </abbr>Enter line of business/group</mat-label>
          <input matInput formControlName="pcGroup" required maxlength="250">
          <mat-error>Please enter line of business/group</mat-error>
        </mat-form-field>
      </div>

    </div>

    <p>
      * A “Political Contribution” includes any gift, subscription, loan, advance, or deposit of money or any thing of
      value made for
      the purpose of influencing any election for federal, state, or local office; for payment or reduction of debt
      incurred in connection with any such election; or for transition or inaugural expenses for a successful candidate.
      These include
      contributions made to candidates for elected office, political parties, political action committees, and any other
      entities
      organized under Section 527 of the Internal Revenue Code.
    </p>
  </form>
</div>
<ng-template #loading>
  Loading Location Confirmation...
</ng-template>